import { lazy } from 'react';

/**
 * Shared Trade page loader so AuthenticatedMobileShell can preload the chunk
 * on mobile without waiting for the first Trade tab tap (avoids chrome flash).
 */
export const loadTradePage = () =>
  import('../pages/Trade').then((m) => ({ default: m.Trade }));

export const TradePage = lazy(loadTradePage);

/** Kick off the Trade chunk download; safe to call repeatedly. */
export function preloadTradePage() {
  return loadTradePage();
}
